import { formatDataTest } from '@/common/dataTest/DataTest';
import { useDialog } from '@/common/dialog/DialogContext';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { GridConstants } from '@/common/grid/GridConstants';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { DateUtils } from '@/common/utils/DateUtils';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Autocomplete, Box, Checkbox, IconButton, TextField, Tooltip } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { McdDispDialog } from './McdDispDialog';

export const McdDispCLDList = () => {
  // TODO: Hardcoded
  const partition = DateUtils.qtrPeriodFromDate(DateUtils.today());

  /* Selectable vals */
  const [selectedVals, setSelectedVals] = useState([]);
  const [vals, setVals] = useState([]);
  const rsrc = useRsrc();
  useEffect(() => {
    rsrc.rows('sc', 'VAL', { expr: ExprUtils.whereParams('entity', 'MCD_UTIL_LINE') }).then((res) => {
      setVals(res);
    });
  }, []);

  /* Add checkbox */
  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.checkbox = GridConstants.checkbox;
  };

  /* Get Client side medicaid util lines */
  const clientSideRowData = useCallback(
    (setDataSource) => {
      const rowsReq = {
        partition,
        expr: ExprUtils.and(
          ExprUtils.notExists('mcdDispId'),
          ExprUtils.exists('mcdLedgerLineId'),
          ExprUtils.exists('rxNum'),
        ),
      };

      /* Filter to selected vals */
      selectedVals.forEach((selectedVal) => {
        rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.contains('valRes', `"${selectedVal.code}"`));
      });

      rsrc.rows('sc', 'MCD_UTIL_LINE', rowsReq).then((res) => {
        setDataSource(res);
      });
    },
    [selectedVals],
  );

  /* Dispute dialog */
  const entityListRef = useRef();
  const { openDialog } = useDialog();

  const openDisputeDialog = () => {
    // Utilization line id's
    const gridApi = entityListRef.current.gridRef.current.gridApiRef.current;
    const selectedLines = gridApi.getSelectedRows();
    const utilLineIds = selectedLines.map((line) => line.id);

    const valCodes = selectedVals.map((val) => val.code);

    const data = {
      utilLineIds,
      valCodes,
      partition,
    };
    openDialog(McdDispDialog, { data });
  };

  return (
    <>
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {/* Title */}
        <Title title="Dispute Ledger Level Details" />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* Val Select */}
          <Autocomplete
            multiple
            disableCloseOnSelect
            filterSelectedOptions
            options={vals}
            getOptionLabel={(option) => option.code}
            value={selectedVals}
            onChange={(_, newValues) => {
              setSelectedVals(newValues);
            }}
            isOptionEqualToValue={(opt, val) => opt.id === val.id} // if your objects have an `id`
            data-test-id={formatDataTest('val-select')}
            renderOption={(props, option, { selected }) => (
              <li {...props} data-test-id={`select-"${option.code}: ${option.msg}"`}>
                <Checkbox style={{ marginRight: 8 }} checked={selected} />
                {`${option.code}: ${option.msg}`}
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} label="Select Validations " placeholder="Select on or more Validations" />
            )}
            sx={{ width: 500 }}
          />

          {/* Dispute button */}
          <Tooltip title="Dispute selected">
            <IconButton size="large" data-test-id="disp-button" onClick={() => openDisputeDialog()}>
              <FontAwesomeIcon icon={fas.faWrench} />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      {/* Main List */}
      <EntityList
        ref={entityListRef}
        showTitle={false}
        entity="MCD_UTIL_LINE"
        augFieldDefs={augFieldDefs}
        clientSideRowData={clientSideRowData}
        gridOptions={{
          rowSelection: 'multiple',
        }}
      />
    </>
  );
};
